import { Dropdown} from "@arco-design/web-react"
import "./index.less"

export default function NewDropdown(props) {
        return <Dropdown
            trigger="click"
            position="bl"
            {...props}/>
}